import "babel-polyfill";
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "@/assets/css/common.scss";
import 'amfe-flexible/index.js';
import { injectBuildTimeStampToWindow } from "../scripts/sync-build-timestamp";
// 已按需引入，文档：http://udpalltest.ledc.changyan.cn/aidp/axe-ui
import {
  Button, Table, Pagination, Input, Select, Option, Form, FormItem, Icon, Breadcrumb, BreadcrumbItem,
  TableColumn, Popover, Tooltip, Tabs, TabPane, Dropdown, DropdownMenu, DropdownItem, Dialog
} from "@aidp/axe-ui"
import { BarChart, PieChart, RadarChart, LineChart } from 'echarts/charts';
import * as echarts from 'echarts/core';
import vueAudioNative from 'vue-audio-native'
import {
  TitleComponent,
  TooltipComponent,
  GridComponent,
  LegendComponent,
  DatasetComponent,
  ToolboxComponent,
  VisualMapComponent,
  PolarComponent,
  DataZoomComponent,
  RadarComponent
} from 'echarts/components';
import {
  CanvasRenderer,
} from 'echarts/renderers';
import { SankeyChart } from 'echarts/charts';

import "@/assets/css/base.css";
import moment from "moment";
// 加载所有插件
import index from '@/utils/index.js';
Vue.use(index);
// import * as echarts from 'echarts'
// Vue.prototype.$echarts = echarts

injectBuildTimeStampToWindow();
Vue.use(Button);
Vue.use(Table);
Vue.use(Pagination);
Vue.use(Input);
Vue.use(Select);
Vue.use(Option);
Vue.use(Form);
Vue.use(FormItem);
Vue.use(Icon);
Vue.use(Breadcrumb);
Vue.use(BreadcrumbItem);
Vue.use(TableColumn);
Vue.use(Popover);
Vue.use(Tooltip);
Vue.use(Tabs);
Vue.use(TabPane);
Vue.use(Dialog);
Vue.use(Dropdown);
Vue.use(DropdownMenu);
Vue.use(DropdownItem);

Vue.prototype.$moment = moment;


Vue.use(vueAudioNative);

echarts.use([
  TitleComponent,
  TooltipComponent,
  GridComponent,
  BarChart,
  PieChart,
  LineChart,
  LegendComponent,
  DatasetComponent,
  CanvasRenderer,
  ToolboxComponent,
  VisualMapComponent,
  RadarChart,
  PolarComponent,
  DataZoomComponent,
  SankeyChart,
  RadarComponent
]);
Vue.prototype.$echarts = echarts;
Vue.config.productionTip = false;
const rootApp = new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");

export default {
  router,
  store,
  rootApp
};